export class TaxPolicyStatus {
  taxPolicyStatusId?: number;
  name!: string;
}
